import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectIsLiveChat } from '../../../../common/selectors/chat';
import { ResetButton } from '../../ResetButton';
import { LiveChatActions } from '../LiveChatActions';

export type ChatbotToggleActionsProps = {
  expanded: boolean;
};

export const ChatbotToggleActions: FC<ChatbotToggleActionsProps> = ({
  expanded,
}) => {
  const isLiveChat = useSelector(selectIsLiveChat);

  if (!expanded) {
    return null;
  }

  return isLiveChat ? (
    <LiveChatActions dataHook="chatbot-toggle-actions__live" />
  ) : (
    <ResetButton dataHook="chatbot-toggle-actions__reset-button" />
  );
};
